module.exports = __webpack_public_path__ + "static/img/profile-header.701b9aae.jpg";